// export const getTranslations = state => i18nSelectors.getTranslations(state.i18n);
export const getLocale = state => state.locale;
export const getRedirectTo = state => state.redirectTo;
